import { Component, EventEmitter, Input, Output } from '@angular/core';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-player-remove',
  templateUrl: './player-remove.component.html',
  styleUrls: ['./player-remove.component.scss']
})
export class PlayerRemoveComponent {

  @Input() player_ids:any = []
  @Input() request_context:any = {}
  @Output() saveEvent = new EventEmitter();
  constructor(private http: HttpService) { }

  async remove() {
    let ids = this.player_ids.filter((v:any) => {
      return v.remove
    })
    let rtn:any = await this.http.post("/admin/player/remove", {ids, ...(this.request_context || {})})
    this.saveEvent.emit(true)
  }

}
